import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../pages/img/tonny.png"

const NavBar = ({Links}) => {

    const [open, setOpen] = useState(false);

    const scrollUp = ()=>{
        setOpen(false)
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    return ( 
        <nav className="font-fonts shadow-xl md:flex md:justify-around  bg-gray-800 w-screen z-10 fixed -mt-4 md:h-16">
            <Link to={Links[0].link}>
                <div className="hidden md:block mt-5"><img src={logo} className='w-24'/></div>
                <div className="flex md:hidden justify-between pt-8 px-4 mt-4 text-3xl">
                    <span className=""><img src={logo} className='w-24'/></span>
                    <label onClick={()=>setOpen(!open)} className='text-slate-200 mr-4 md:hidden'>
                        <ion-icon name={open ? 'close-sharp': 'menu-sharp'}></ion-icon>
                    </label>
                </div>
            </Link>
            <ol className={`md:mt-4 md:block ${open ? 'block':'hidden'} bg-gray-800 h-screen md:h-auto`}>
                {Links.map((value)=>(
                    <li className="hover:opacity-50 md:inline-block md:mx-6  font-fonts mx-14 block md:mt-0 py-2 text-slate-200">
                        <Link onClick={scrollUp} to={value.link} className='active:text-yellow-200'>{value.name}</Link>
                    </li>
                ))}
            </ol>
        </nav>
     );
}
 
export default NavBar;
